import React from 'react';
import { CardContent, Stack, TextField, MenuItem, Button, Typography } from '@mui/material';
import { FilterList as FilterListIcon } from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Dayjs } from 'dayjs';
import { FacilityReportFilters } from '../../../../../services/ReportingService';
import { EnumView } from '../../../../../services/DimensionService/types/dimensionTypes';

interface WorkOrderReportFiltersProps {
  filters: FacilityReportFilters;
  onFiltersChange: (filters: FacilityReportFilters) => void;
  fromDate: Dayjs | null;
  onFromDateChange: (date: Dayjs | null) => void;
  toDate: Dayjs | null;
  onToDateChange: (date: Dayjs | null) => void;
  centers: EnumView[];
  centersLoading: boolean;
  issueTypes: EnumView[];
  issueTypesLoading: boolean;
  onApplyFilters: () => void;
  onResetFilters: () => void;
}

const WorkOrderReportFilters: React.FC<WorkOrderReportFiltersProps> = ({
  filters,
  onFiltersChange,
  fromDate,
  onFromDateChange,
  toDate,
  onToDateChange,
  centers,
  centersLoading,
  issueTypes,
  issueTypesLoading,
  onApplyFilters,
  onResetFilters,
}) => {
  return (
    <CardContent sx={{ p: 3, backgroundColor: '#f8fafc' }}>
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <FilterListIcon sx={{ color: '#64748b', fontSize: '1.2rem' }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b' }}>
          Filters
        </Typography>
      </Stack>
      <Stack spacing={2}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
          <TextField
            select
            fullWidth
            size="small"
            label="Center"
            value={filters.centerId}
            onChange={(e) => onFiltersChange({ ...filters, centerId: e.target.value })}
            disabled={centersLoading}
            sx={{ flex: 1 }}
          >
            <MenuItem value="">All Centers</MenuItem>
            {centers.map((center) => (
              <MenuItem key={center.value} value={center.value}>
                {center.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            fullWidth
            size="small"
            label="Issue Type"
            value={filters.issueType}
            onChange={(e) => onFiltersChange({ ...filters, issueType: e.target.value })}
            disabled={issueTypesLoading}
            sx={{ flex: 1 }}
          >
            <MenuItem value="">All Issue Types</MenuItem>
            {issueTypes.map((type) => (
              <MenuItem key={type.value} value={type.value}>
                {type.name}
              </MenuItem>
            ))}
          </TextField>
          <DatePicker
            label="From Date"
            value={fromDate}
            onChange={onFromDateChange}
            slotProps={{ textField: { size: 'small', fullWidth: true, sx: { flex: 1 } } }}
          />
          <DatePicker
            label="To Date"
            value={toDate}
            onChange={onToDateChange}
            slotProps={{ textField: { size: 'small', fullWidth: true, sx: { flex: 1 } } }}
          />
        </Stack>
        <Stack direction="row" spacing={1} sx={{ justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            onClick={onApplyFilters}
            sx={{
              backgroundColor: '#3b82f6',
              '&:hover': { backgroundColor: '#2563eb' },
              minWidth: '100px',
            }}
          >
            Apply
          </Button>
          <Button variant="outlined" onClick={onResetFilters} sx={{ minWidth: '80px' }}>
            Reset
          </Button>
        </Stack>
      </Stack>
    </CardContent>
  );
};

export default WorkOrderReportFilters;
